<div class="sidebar-menu-inner" *ngIf="isValidUser">
			
  <header class="logo-env" style="background: #585755;">

    <!-- logo -->
    <div class="logo">
      <a [routerLink]="['/']">
        <img src="{{logoSrc}}" width="120" alt="" />
      </a>
    </div>

    <!-- logo collapse icon -->
    <div class="sidebar-collapse" onclick="showHideSecondLogo()">
      <a href="#" class="sidebar-collapse-icon" onclick=""><!-- add class "with-animation" if you want sidebar to have animation during expanding/collapsing transition -->
        <i class="entypo-menu"></i>
      </a>
    </div>

            
    <!-- open/close menu icon (do not remove if you want to enable menu on mobile devices) -->
    <div class="sidebar-mobile-menu visible-xs">
      <a href="#" class="with-animation"><!-- add class "with-animation" to support animation -->
        <i class="entypo-menu"></i>
      </a>
    </div>

  </header>
                    
  <ul id="main-menu" class="main-menu">
    <!-- add class "multiple-expanded" to allow multiple submenus to open -->
    <!-- class "auto-inherit-active-class" will automatically add "active" class for parent elements who are marked already with class "active" -->
    <li class="opened active">
      <a [routerLink]="['/']">
        <i class="entypo-gauge"></i>
        <span class="title">Dashboard</span>
      </a>
    </li>
    <li class="has-sub">
      <a href="#">
        <i><img src="assets/NavIcons/safety.svg" style="width: 20px;"></i>
        <!--<i class="entypo-eye"></i>-->
        <span class="title">Observation / Interventions</span>
      </a>
      <ul>
        <li *ngIf="permissions.SUPER_Admin || permissions.OBS_Add || permissions.OBS_Add_Unit || permissions.OBS_Admin || permissions.OBS_Admin_Unit">
          <!-- <p style="margin-left:21px;" 
              [routerLink]="['/observation/make-observation', 'new']"> -->
          <a [routerLink]="['/observation/make-observation', 'new']">
            <span class="title">Make Observation</span>
          </a>
          <!-- </p> -->
        </li>
        <li>
          <!-- <p *ngIf="!permissions.OBS_Add && !permissions.OBS_Add_Unit  && !permissions.OBS_Admin && !permissions.OBS_Admin_Unit"
              [routerLink]="['/observation/observation-card-overview']"> -->
          <a [routerLink]="['/observation/observation-card-overview']">
            <span class="title">Observations Overview</span>
          </a>
          <!-- </p> -->
        </li>


      </ul>
    </li>

    <li class="has-sub">
      <a href="#">
        <i><img src="assets/NavIcons/Incident.svg" style="width: 20px;"></i>
        <!--<i class="entypo-alert"></i>-->
        <span class="title">Incident Management</span>
      </a>
      <ul>
        <li *ngIf="isOnline && (permissions.SUPER_Admin || permissions.INC_Add || permissions.INC_Add_Unit || permissions.INC_Admin || permissions.INC_Admin_Unit)">
          <a [routerLink]="['/incident/report-incident', 'new']">

            <span class="title">Report Incident </span>
          </a>
        </li>
        <li>
          <a [routerLink]="['/incident/incident-overview']">

            <span class="title">Incident Overview</span>
          </a>
        </li>

      </ul>
    </li>


    <li class="has-sub">
      <a href="#">
        <!--<i class="entypo-check"></i>-->
        <i><img src="assets/NavIcons/inspect.svg" style="width: 20px;"></i>
        <span class="title">Inspection & Audit</span>

      </a>
      <ul>
          <li></li>
        <li *ngIf="isOnline && (permissions.SUPER_Admin || permissions.INSP_Add || permissions.INSP_Add_Unit || permissions.INSP_Admin || permissions.INSP_Admin_Unit)">
          <a [routerLink]="['/inspection/add-inspection/new']">
            <span class="title">Add Inspection</span>
          </a>
        </li>
        <li>
          <a [routerLink]="['/inspection/inspections-overview']">
            <span class="title">Inspections Overview</span>
          </a>
        </li>


      </ul>
    </li>


    <li class="has-sub">
      <a href="#">
        <i><img src="assets/NavIcons/permit to wotk.svg" style="width: 20px;"></i>
        <!--<i class="entypo-ticket"></i>-->
        <span class="title">Permit To Work</span>

      </a>
      <ul>
       
        <li *ngIf="isOnline && (permissions.SUPER_Admin || permissions.PTW_Add || permissions.PTW_Add_Unit || permissions.PTW_Admin || permissions.PTW_Admin_Unit)">
          <a [routerLink]="['/ptw/raise-permit']">
            <span class="title">Apply Permit</span>
          </a>
        </li>
        
        <li>
          <a [routerLink]="['/ptw/permit-overview']">
            <span class="title">Permit Overview</span>
          </a>
        </li>
        
        <li>
          <a [routerLink]="['/ptw/map-view/']">
            <span class="title">Map View</span>
          </a>
        </li>

      </ul>
    </li>


    <li class="has-sub">
      <a href="#">
        <!--<i class="entypo-users"></i>-->
        <i><img src="assets/NavIcons/person.svg" style="width: 20px;"></i>
        <span class="title">Person On Board</span>

      </a>
      <ul>

        <li *ngIf="(permissions.SUPER_Admin || permissions.POB_Contractor_Add || permissions.POB_Contractor_Add_Unit || permissions.POB_Staff_Add || permissions.POB_Staff_Add_Unit || permissions.POB_Admin || permissions.POB_Admin_Unit)">
          <a [routerLink]="['/pob/raise-passrequest/new']">
            <span class="title">New Pass</span>
          </a>
        </li>
        <li>
          <a [routerLink]="['/pob/pass-request-overview']">
            <span class="title">Pass Overview</span>
          </a>
        </li>
        <li>
          <a [routerLink]="['/pob/pob-list-overview']">
            <span class="title">POB List Overview</span>
          </a>
        </li>
        <li>
          <a [routerLink]="['/pob/check-in-out']">
            <span class="title">Check In/Out</span>
          </a>
        </li>

      </ul>
    </li>




    <li class="has-sub">
      <a href="#">
        <!--<i class="entypo-book"></i>-->
        <i><img src="assets/NavIcons/Training.svg" style="width: 20px;"></i>
        <span class="title">Training & Certification</span>

      </a>
      <ul>

        <li *ngIf="isOnline && (permissions.SUPER_Admin || permissions.TNC_Add || permissions.TNC_Add_Unit || permissions.TNC_Admin || permissions.TNC_Admin_Unit)">
          <a [routerLink]="['/tnc/assign-training']">
            <span class="title">Assign Training / Certification</span>
          </a>
        </li>
        <li>
          <a [routerLink]="['/tnc/tnc-overview']">
            <span class="title">Training / Certification Overview</span>
          </a>
        </li>
        <li>
          <a [routerLink]="['/tnc/user-profile/']">
            <span class="title">User Profile</span>
          </a>
        </li>

      </ul>
    </li>

    <li class="has-sub">
      <a href="#">
        <!--<i class="entypo-flow-tree"></i>-->
        <i><img src="assets/NavIcons/task monitor.svg" style="width: 20px;"></i>
        <span class="title">Task Monitor</span>

      </a>
      <ul>

        <li *ngIf="isOnline && (permissions.SUPER_Admin || permissions.TSK_Add || permissions.TSK_Add_Unit || permissions.TSK_Admin || permissions.TSK_Admin_Unit)">
          <a [routerLink]="['/task/task']">
            <span class="title">Task Setup</span>
          </a>
        </li>
        <li>
          <a [routerLink]="['/task/task-list']">
            <span class="title">Task Overview</span>
          </a>
        </li>
        <li>
          <a [routerLink]="['/task/monitoring-matrix']">
            <span class="title">Monitoring Matrix</span>
          </a>
        </li>

      </ul>
    </li>


    <li class="has-sub">
      <a href="#">
        <!--<i class="entypo-lifebuoy"></i>-->
        <i><img src="assets/NavIcons/action tracker.svg" style="width: 20px;"></i>
        <span class="title">Action Tracker</span>
      </a>
      <ul>
        <li *ngIf="isOnline  && (permissions.SUPER_Admin || permissions.ACT_Add || permissions.ACT_Add_Unit || permissions.ACT_Admin || permissions.ACT_Admin_Unit)">
          <a [routerLink]="['/actiontracker/source-action']">
            <span class="title">Action Source</span>
          </a>
        </li>
        <li>
          <a [routerLink]="['/actiontracker/actions-overview']">
            <span class="title">Actions Overview</span>
          </a>
        </li>

      </ul>
    </li>

    <li class="has-sub">
      <a href="#">
        <!--<i class="entypo-attention"></i>-->
        <i><img src="assets/NavIcons/risk management.svg" style="width: 20px;"></i>
        <span class="title">Risk Management</span>
      </a>
      <ul>
        <!-- <li *ngIf="isOnline  && (permissions.SUPER_Admin || permissions.RSK_Add || permissions.RSK_Add_Unit || permissions.RSK_Admin || permissions.RSK_Admin_Unit)">
          <a [routerLink]="['/risk/raise-risk/new']">
            <span class="title">Raise Risk </span>
          </a>
        </li>  -->
        <li  class="has-sub">
          <a href="#">
            <span class="title">Raise Risk </span>
          </a>
          <ul>
           
            <li>
              <a [routerLink]="['/risk/raise-risk-moc/New']">
                <span class="title">MOC</span>
              </a>
            </li>
            <li>
              <a [routerLink]="['/risk/raise-risk-jsa/new']">
                <span class="title">JSA</span>
              </a>
            </li>
            <li>
              <a [routerLink]="['/risk/raise-risk-hemp/new']">
                <span class="title">HEMP</span>
              </a>
            </li>
            <li>
              <a [routerLink]="['/risk/raise-risk-hazop/new']">
                <span class="title">HAZOP</span>
              </a>
            </li>
            <li>
              <a [routerLink]="['/risk/raise-risk-hazid/new']">
                <span class="title">HAZID</span>
              </a>
            </li>    
          </ul>
        </li>

        <li>
          <a [routerLink]="['/risk/risk-overview']">
            <span class="title">Risk Register Overview</span>
          </a>
        </li>
        <li>
          <a [routerLink]="['/risk/risk-Approval']">
            <span class="title">Pending Approvals</span>
          </a>
        </li>
      </ul>
    </li>
    <li class="has-sub">
      <a href="#">
        <i class="entypo-chart-pie"></i>
        <!--<i><img src="assets/NavIcons/1performance.svg" style="width: 20px;"></i>-->

        <span class="title">Performance Dashboard</span>

      </a>
      <ul>

        <li>
          <a [routerLink]="['/pd/dashboard/']">
            <span class="title">Performance Dashboard</span>
          </a>
        </li>
        <li>
          <a [routerLink]="['/pd/statistic/']">
            <span class="title">Contractor Statistics</span>
          </a>
        </li>
        <li>
          <a [routerLink]="['/pd/overview']">
            <span class="title">Contractor Statistics Overview</span>
          </a>
        </li>

      </ul>
    </li>

    <li>
      <a [routerLink]="['/dl/document-library']">
        <i class="entypo-folder"></i>
        <!--<i><img src="assets/NavIcons/11folder.svg" style="width: 20px;"></i>-->
        <span class="title">Document Library</span>
      </a>
    </li>


    <li *ngIf="permissions.HSE_Admin || permissions.APP_Admin || permissions.SUPER_Admin">
      <a [routerLink]="['/masterscreen/welcome']">
        <i class="entypo-lock-open"></i>

        <span class="title">Admin </span>
      </a>   
    </li>
    <li>
      <a [routerLink]="['/faq']">
        <i class="entypo-help"></i>

        <span class="title">Help & Support </span>
      </a>
    </li>
  </ul>
  <footer  >
    
   

     
  </footer>
</div>
